module.exports = __webpack_public_path__ + "deafe6f2101054788df42c704660453d.svg";